import React from 'react';

import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { BrokerOption } from '../types';
import type { Filters, SelectOption } from './types';

type Slice = Pick<Filters, 'brokers'>;
interface Props extends Slice {
  brokerOptions: BrokerOption[];
  onChange: (changes: Slice) => void;
}

function getBrokerOption(broker: BrokerOption): SelectOption {
  return {
    label: (
      <div className={`profile-name mb-2 ${broker.imageUrl ? 'py-0' : ''}`}>
        {broker.imageUrl ? (
          <img className="img-circle profile-image-tiny" src={broker.imageUrl} />
        ) : (
          <FontAwesomeIcon className="text-muted profile-image-tiny ml-1" icon={faUsers} />
        )}
        {broker.name}
      </div>
    ),
    value: broker.id.toString(),
  };
}

export default function ActivityBrokerFilter({ brokers, brokerOptions, onChange }: Props) {
  return (
    <CheckboxFilter
      addFilter={(_name, filter) => onChange({ brokers: [...brokers, filter] })}
      className="ml-0"
      hideClearControl={!brokers.length}
      hideSelectedCount={!brokers.length}
      label="Broker"
      options={brokerOptions.map(getBrokerOption)}
      removeFilter={(_name, filter) => onChange({ brokers: brokers.filter(t => t !== filter) })}
      selected={brokers}
      onClear={() => onChange({ brokers: [] })}
    />
  );
}
